




import Vue from 'vue'
import Tutorial from '../components/Tutorial.vue'

export default Vue.extend({
  components: {
    Tutorial
  },
  created: function () {
    this.$store.state.showTopNavigation = false;
  }
})
